const { jQuery: $ } = window;

export default class NavBar {
    #$header;
    #$nav;
    #$hamburger;
    #$cross;
    #$search;
    #$menuItem;
    #$submenus;
    #$submenuItem;
    #$descriptions;
    #utils;

    constructor(utils) {
        this.#utils = utils;
        this.#$header = $(".site_header");
        this.#$nav = this.#$header.find(".site_header__menu");
        this.#$hamburger = this.#$header.find('.site_header__hamburger');
        this.#$cross = this.#$header.find('.site_header__closeBtn');
        this.#$search = this.#$header.find('.site_header__search .search-button');
        this.#$menuItem = this.#$header.find('.menu-item');
        this.#$submenus = this.#$header.find('.site_header__subNav');
    }

    events() {
        const me = this;

        //Header Open/Close
        me.#$hamburger.on('click', function(){
            me.#$header.toggleClass('js-open');
        });

        me.#$cross.on('click', function(){
            me.closeMenu();
        });

        //Search Bar open/close
        me.#$search.on('click', function(){
            me.#$header.toggleClass('js-search-open');
            $(this).parent().toggleClass('js-open');
        });

        me.#$menuItem.on('mouseover', function() {
            me.#$menuItem.removeClass("js-active");

            if($(this).is(".menu-item-has-children")) {
                $(this).addClass("js-active");
                me.#$submenus.html($(this).children(".sub-menu")[0].outerHTML);

            } else {
                me.#$submenus.html("");
            }
        });

        $(document).on('click', ".menu-item", function() {
            console.log(this);

            $(this).parent().find(".menu-item").removeClass("js-active");

            if($(this).is(".menu-item-has-children")) {
                $(this).addClass("js-active");
            }
        });
    }

    closeMenu() {
        this.#$header.removeClass('js-open')
            .removeClass('js-search-open')
            .removeClass("js-submenu-open");

        this.#$menuItem.removeClass("js-active");
        this.#$search.parent().removeClass('js-open');
    }
}